import { arrayHas } from "../../utils/arrayHas.js";
import { notEmptyActions } from "./notEmptyActions.js";
import { Observable } from "rxjs";
//#region src/engine/rx-operators/actionsFilter.ts
var actionsFilter = (actionTypes) => {
	const has = arrayHas(actionTypes);
	return (source$) => new Observable((subscriber) => source$.subscribe({
		next: (actions) => subscriber.next(actions.filter((action) => has(action.type))),
		error: (err) => subscriber.error(err),
		complete: () => subscriber.complete()
	})).pipe(notEmptyActions);
};
//#endregion
export { actionsFilter };
